import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatRupiah } from "../lib/api";
import { Heart, BookOpen, Brain, Calendar, Clock } from "lucide-react";

const TYPES = [
  { v: "", l: "Semua" },
  { v: "counseling", l: "Konseling" },
  { v: "workshop", l: "Workshop" },
  { v: "training", l: "Training" },
  { v: "seminar", l: "Seminar" },
];
const ICONS = { counseling: Heart, workshop: BookOpen, training: Brain, seminar: Calendar };

export default function Services() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("");
  useEffect(() => {
    api.get(`/services${type ? `?type=${type}` : ""}`).then(r => setItems(r.data));
  }, [type]);
  return (
    <div data-testid="services-page">
      <section className="lumina-bg-soft py-20">
        <div className="lumina-container">
          <div className="lumina-label mb-3">Layanan</div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter text-[#1A1728] mb-6 max-w-3xl">Konseling, workshop, training & seminar.</h1>
          <p className="text-lg text-[#5C5870] max-w-2xl">Dipandu psikolog berlisensi, dirancang sesuai kebutuhanmu — individu maupun perusahaan.</p>
          <div className="flex flex-wrap gap-3 mt-10">
            {TYPES.map(t => (
              <button key={t.v} onClick={() => setType(t.v)} data-testid={`filter-svc-${t.v || "all"}`}
                className={`px-5 py-2 rounded-full text-sm font-medium ${type === t.v ? "bg-[#6B4BA3] text-white" : "bg-white border border-[#E2DFED] text-[#5C5870] hover:border-[#6B4BA3]"}`}>
                {t.l}
              </button>
            ))}
          </div>
        </div>
      </section>
      <section className="lumina-container py-16">
        <div className="grid md:grid-cols-2 gap-6">
          {items.map(s => {
            const Icon = ICONS[s.type] || Heart;
            return (
              <Link to={`/services/${s.slug}`} key={s.id} className="lumina-card overflow-hidden group flex flex-col md:flex-row" data-testid={`service-card-${s.slug}`}>
                <div className="md:w-2/5 aspect-[4/3] md:aspect-auto overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-7 md:w-3/5">
                  <div className="flex items-center gap-2 mb-3">
                    <Icon className="w-4 h-4 text-[#6B4BA3]" />
                    <span className="lumina-label">{s.type}</span>
                  </div>
                  <h3 className="font-serif text-2xl text-[#1A1728] mb-3 leading-tight">{s.title}</h3>
                  <p className="text-sm text-[#5C5870] leading-relaxed mb-4 line-clamp-2">{s.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-[#6B4BA3] font-semibold text-lg">{formatRupiah(s.price)}</span>
                    <span className="flex items-center gap-1 text-xs text-[#5C5870]"><Clock className="w-3.5 h-3.5" /> {s.duration_minutes} mnt</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
